import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  message: {
    color: 'red',
    textAlign: 'center',
  },
}));

const Unauthorized = () => {
  const classes = useStyles();

  return (
    <div>
      <p className={classes.message}>
        {' '}
        You do not have permission to access this site. You can contact&nbsp;
        <a href="CPMTAccounts@saic.com">CPMTAccounts@saic.com</a> to request
        access.{' '}
      </p>
    </div>
  );
};

export default Unauthorized;
